/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RocketWarehouseResVo } from './RocketWarehouseResVo';
import {
    RocketWarehouseResVoFromJSON,
    RocketWarehouseResVoFromJSONTyped,
    RocketWarehouseResVoToJSON,
    RocketWarehouseResVoToJSONTyped,
} from './RocketWarehouseResVo';

/**
 * 
 * @export
 * @interface ResponseListRocketWarehouseResVo
 */
export interface ResponseListRocketWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListRocketWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListRocketWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<RocketWarehouseResVo>}
     * @memberof ResponseListRocketWarehouseResVo
     */
    data?: Array<RocketWarehouseResVo>;
}

/**
 * Check if a given object implements the ResponseListRocketWarehouseResVo interface.
 */
export function instanceOfResponseListRocketWarehouseResVo(value: object): value is ResponseListRocketWarehouseResVo {
    return true;
}

export function ResponseListRocketWarehouseResVoFromJSON(json: any): ResponseListRocketWarehouseResVo {
    return ResponseListRocketWarehouseResVoFromJSONTyped(json, false);
}

export function ResponseListRocketWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListRocketWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RocketWarehouseResVoFromJSON)),
    };
}

export function ResponseListRocketWarehouseResVoToJSON(json: any): ResponseListRocketWarehouseResVo {
    return ResponseListRocketWarehouseResVoToJSONTyped(json, false);
}

export function ResponseListRocketWarehouseResVoToJSONTyped(value?: ResponseListRocketWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RocketWarehouseResVoToJSON)),
    };
}

